import clsx from "clsx";
import { FC } from "react";
import { IAnalystTrendsDto } from "../../../../../../../../services/tipRanks/types";
import styles from "./RatingTable.module.scss";
import { useTranslation } from "next-i18next";

const getGroupedData = (data: IAnalystTrendsDto[]) => {
    return data.reduce(
        (acc, item) => {
            acc.date.push(item.period);
            acc.strongBuy.push(item.strongBuy);
            acc.buy.push(item.buy);
            acc.hold.push(item.hold);
            acc.sell.push(item.sell);
            acc.strongSell.push(item.strongSell);
            return acc;
        },
        {
            buy: [],
            date: [],
            hold: [],
            sell: [],
            strongBuy: [],
            strongSell: [],
        }
    );
};

const calculateTotal = (data: IAnalystTrendsDto): number => {
    return data.strongBuy + data.buy + data.hold + data.sell + data.strongSell;
};

export const AnalystTrendsTable: FC<{ data: IAnalystTrendsDto[] }> = ({ data }) => {
    const { t } = useTranslation("common");
    const strongBuyLabel = t("analytics.analystForecasts.gauges.labels.strongBuy").replace(
        /\n/g,
        " "
    );
    const strongSellLabel = t("analytics.analystForecasts.gauges.labels.strongSell").replace(
        /\n/g,
        " "
    );
    const fiveMonthsData = data.slice(-5);
    const groupedData = getGroupedData(fiveMonthsData);

    return (
        <div className={styles.tableContainer}>
            <div className={styles.gridTable}>
                <div className={clsx(styles.gridHeader, styles.rating)}>
                    {t("analytics.analystForecasts.ratingTable.rating")}
                </div>
                {groupedData.date.map((item, index) => (
                    <div key={index} className={styles.gridHeader}>
                        {item}
                    </div>
                ))}

                <div className={clsx(styles.gridCell, styles.strongBuy)}>{strongBuyLabel}</div>
                {groupedData.strongBuy.map((item, index) => (
                    <div key={index} className={styles.gridCell}>
                        {item}
                    </div>
                ))}

                <div className={clsx(styles.gridCell, styles.buy)}>{t("buy")}</div>
                {groupedData.buy.map((item, index) => (
                    <div key={index} className={styles.gridCell}>
                        {item}
                    </div>
                ))}

                <div className={clsx(styles.gridCell, styles.hold)}>{t("hold")}</div>
                {groupedData.hold.map((item, index) => (
                    <div key={index} className={styles.gridCell}>
                        {item}
                    </div>
                ))}

                <div className={clsx(styles.gridCell, styles.sell)}>{t("sell")}</div>
                {groupedData.sell.map((item, index) => (
                    <div key={index} className={styles.gridCell}>
                        {item}
                    </div>
                ))}

                <div className={clsx(styles.gridCell, styles.strongSell)}>{strongSellLabel}</div>
                {groupedData.strongSell.map((item, index) => (
                    <div key={index} className={styles.gridCell}>
                        {item}
                    </div>
                ))}

                <div className={clsx(styles.gridCell, styles.total)}>
                    {t("analytics.analystForecasts.ratingTable.total")}
                </div>
                {fiveMonthsData.map((item, index) => (
                    <div key={index} className={clsx(styles.gridCell, styles.strongText)}>
                        {calculateTotal(item)}
                    </div>
                ))}
            </div>
        </div>
    );
};
